<template>
   <Head>
      <title>{{ $t("meta.home.title") }}</title>
      <meta name="description" :content="$t('meta.home.content')" />
   </Head>

   <PageLoader :isLoading="isLoading" :loadErrors="loadErrors">
      <div class="mb-20 flex flex-col items-center" data-cy="logged-in-home-page">
         <GreetingSection v-if="greetingSectionContent" v-bind="greetingSectionContent" :userName="userName" />

         <CardsContainer :cards="cards" />
      </div>
   </PageLoader>
</template>

<script setup lang="ts">
import { Head } from "@unhead/vue/components";
import ContentApi, { type PageContent } from "@/data/api-layer/contentApi";
import UsersApi from "@/data/api-layer/usersApi";
import { useI18n } from "@/vue-i18n/vue-i18n";
import { useUserStore } from "@/stores/userStore";

const { isLoading, execManyRequests, loadErrors } = useApiRequest();
const { t: $t } = useI18n();
const pageContent = ref<PageContent>(null);
const userFeed = ref<[]>([]);
const userStore = useUserStore();

// lifecycle
// ---------------------------------------
onMounted(async () => {
   const responses = await execManyRequests([() => ContentApi.getHome(), () => UsersApi.getHomeFeed()]);
   if (loadErrors.value.length > 0) return;

   pageContent.value = responses[0].value.content;
   userFeed.value = responses[1].value;
});

// computed
// ----------------------------------------
const cards = computed(() => {
   if (!pageContent.value?.sections) return null;

   // get static cards
   const cardsSection = pageContent.value.sections.find((content) => content.type === "cards_section");
   const staticCards = cardsSection?.cards || [];

   const cards = userFeed.value.concat(staticCards);

   //  update cards state
   return cards;
});

const userName = computed((): string | null => userStore.user?.name || null);

const greetingSectionContent = computed(() => {
   if (!pageContent.value?.sections) return null;

   return pageContent.value.sections.find((content) => content.type === "greeting_section");
});
</script>

<style scoped lang="scss"></style>
